import { lazy, Suspense } from 'react';

import { PAYRUN_COMPONENTS } from '@xemplo/gp-constants';
import { RoleRenderer } from '@xemplo/role-renderer';
import { AuthorisationModule } from '@xemplo/role-types';

import { EditButtonFactoryProps } from './edit-button.types';

const EditAmendment = lazy(() =>
  import('@xemplo/edit-amendment-modal').then((m) => ({ default: m.EditAmendmentModal }))
);
const EditTermination = lazy(() =>
  import('@xemplo/edit-termination-modal').then((m) => ({
    default: m.EditTerminationModal,
  }))
);
const EditPayInstruction = lazy(() =>
  import('@xemplo/edit-pay-instruction-modal').then((m) => ({
    default: m.EditPayInstructionModal,
  }))
);

export const LazyEditButtonMap = {
  amendment: EditAmendment,
  termination: EditTermination,
  payInstruction: EditPayInstruction,
};

export const EditButtonFactory = (props: EditButtonFactoryProps) => {
  const { type, amendmentId, onSubmitSuccess } = props;
  if (!type) return null;
  const EditButton = LazyEditButtonMap[type];
  return (
    <RoleRenderer
      module={AuthorisationModule.payrun}
      component={PAYRUN_COMPONENTS.AMENDMENT_EDIT}
    >
      <Suspense>
        <EditButton amendmentId={amendmentId} onSubmitSuccess={onSubmitSuccess} />
      </Suspense>
    </RoleRenderer>
  );
};
